// SEO / JSON-LD for the Case Studies page.
export const caseStudiesJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  '@id': 'https://digitallybaffled.com/case-studies#webpage',
  name: 'Case Studies — Real Results for Real Businesses | Digitally Baffled',
  url: 'https://digitallybaffled.com/case-studies',
  description: 'Real digital transformation results for UK small businesses. See how Digitally Baffled LTD helped Eclipse Paving generate over £70,000 in work through Google Ads, web design, SEO & AEO, and Google Business Profile setup, and how BowlScoreboard went from client to partnership.',
  isPartOf: { '@id': 'https://digitallybaffled.com/#website' },
  about: { '@id': 'https://digitallybaffled.com/#organization' },
  inLanguage: 'en-GB',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://digitallybaffled.com/' },
      { '@type': 'ListItem', position: 2, name: 'Case Studies', item: 'https://digitallybaffled.com/case-studies' },
    ],
  },
};

export const caseStudiesItemListJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Digitally Baffled Case Studies',
  url: 'https://digitallybaffled.com/case-studies',
  description: 'Case studies showing real digital transformation results delivered by Digitally Baffled LTD for UK small businesses.',
  numberOfItems: 2,
  itemListElement: [

    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'CaseStudy',
        '@id': 'https://digitallybaffled.com/case-studies#eclipse-paving',
        name: 'Eclipse Paving — From Zero Online Presence to £70,000+ in Work Generated',
        headline: 'Eclipse Paving: £70,000+ in work generated through Google Ads, web design, and SEO',
        url: 'https://digitallybaffled.com/case-studies',
        image: 'https://digitallybaffled.com/__l5e/assets-v1/c5e51063-16d0-498a-8762-7513b7de61dd/portfolio-eclipse-paving.jpg',
        datePublished: '2025-01-01',
        author: { '@type': 'Organization', '@id': 'https://digitallybaffled.com/#organization', name: 'Digitally Baffled LTD' },
        about: {
          '@type': 'Organization',
          name: 'Eclipse Paving',
          url: 'https://www.eclipsepaving.com',
          description: 'Specialist driveway and paving company in the UK',
          industry: 'Driveways & Paving',
        },
        description: 'Justin Kirby runs Eclipse Paving, a specialist driveway and paving company. When he came to Digitally Baffled he had zero online presence and needed consistent, high-quality leads. Digitally Baffled built his website from the ground up, handled full SEO and AEO optimisation, implemented Google Tag Manager and Analytics tracking, set up his Google Business Profile, and launched and continues to manage his Google Ads campaigns.',
        keywords: ['Google Ads', 'Web Design', 'SEO', 'AEO', 'Google Business Profile', 'Google Tag Manager', 'Analytics', 'Driveways', 'Paving', 'Lead Generation'],
        serviceProvided: [
          'Web Design & Development',
          'SEO & AEO Optimisation',
          'Google Ads Setup & Management',
          'Google Tag Manager Implementation',
          'Google Analytics Tracking',
          'Google Business Profile Setup',
        ],
        result: {
          '@type': 'QuantitativeValue',
          description: 'Over £70,000 worth of work directly attributed to Google Ads campaigns managed by Digitally Baffled LTD. Eclipse Paving went from zero online presence to a fully managed digital operation. Justin Kirby is an ongoing client — Digitally Baffled continues to manage his ads, monitor performance, and support his growth month on month.',
          value: 70000,
          minValue: 70000,
          unitCode: 'GBP',
          unitText: 'GBP revenue generated',
        },
        review: {
          '@type': 'Review',
          author: { '@type': 'Person', name: 'Justin Kirby', jobTitle: 'Founder', worksFor: { '@type': 'Organization', name: 'Eclipse Paving' } },
          reviewBody: "From zero online presence to a fully managed digital operation. Morgan and the team explained everything in plain English, built us a site we're proud of, and the leads have been coming in ever since.",
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5', worstRating: '1' },
          datePublished: '2025-01-01',
          itemReviewed: { '@type': 'Organization', '@id': 'https://digitallybaffled.com/#organization', name: 'Digitally Baffled LTD' },
        },
      },
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'CaseStudy',
        '@id': 'https://digitallybaffled.com/case-studies#bowlscoreboard',
        name: 'BowlScoreboard — from client to partnership',
        headline: 'BowlScoreboard — from client to partnership',
        url: 'https://digitallybaffled.com/case-studies',
        author: { '@type': 'Organization', '@id': 'https://digitallybaffled.com/#organization', name: 'Digitally Baffled LTD' },
        about: {
          '@type': 'Organization',
          name: 'BowlScoreboard',
          url: 'https://bowlscoreboard.co.uk',
          industry: 'BowlScoreboard',
        },
        description:
          "When BowlScoreboard came to us, the product was already the best on the market — bespoke, hand-built mechanical scoreboards winning clubs across the UK on quality alone. What it lacked was the brand, website and structure to support its growth. Through our Vision to Launch package and a new website, we refreshed the brand and helped reshape the business model itself. Instead of clubs buying their own board, businesses can now sponsor the advertising space, allowing clubs to receive a scoreboard free of charge while sponsors gain a lasting presence in front of players, members and spectators. And because that sponsorship puts the scoreboard there, they're not just advertising at the club — they're the business that gave the club its scoreboard. Digitally Baffled now manages the sale of BowlScoreboard's advertising space, and works alongside its leadership on commercial strategy. We believed in the business enough to become part of it.",
        disambiguatingDescription:
          "Digitally Baffled runs BowlScoreboard's advertising sales and works alongside its leadership on commercial strategy — a partnership that grew out of this project.",
        serviceProvided: ['Vision to Launch', 'Website'],
        review: {
          '@type': 'Review',
          author: { '@type': 'Person', name: 'Chris P Spry', jobTitle: 'Founder & CEO', worksFor: { '@type': 'Organization', name: 'BowlScoreboard' } },
          reviewBody:
            "We were an operational business making good sales when we sat down with Digitally Baffled. They rebuilt our brand and website — but the bigger thing was the idea they brought to the table: give clubs the board free, and fund it through local businesses sponsoring the advertising space. It changed how the whole company works. We ended up bringing them in to run our ad sales, and onto our commercial team. That says it all really.",
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5', worstRating: '1' },
          itemReviewed: { '@type': 'Organization', '@id': 'https://digitallybaffled.com/#organization', name: 'Digitally Baffled LTD' },
        },
      },
    },
  ],
};

